import {
    ADD_ALERT,
    AlertsAction,
    CLEAR_ALERT,
    REMOVE_ALERT,
    REMOVE_ALERTS_BY_SCREEN
} from 'actions/alerts/AlertsActionsTypes';
import { AlertsState } from 'reducers/alerts/AlertsState';

const initialState: AlertsState = [];

export const alertsReducer = (state: AlertsState = initialState, action: AlertsAction) => {
    switch (action.type) {
        case ADD_ALERT:
            return [...state, action.payload.alert];
        case REMOVE_ALERT:
            return [...state.filter(alert => alert.uuid !== action.payload.uuid)];
        case REMOVE_ALERTS_BY_SCREEN:
            return [...state.filter(alert => alert.screen !== action.payload.screen)];
        case CLEAR_ALERT:
            return initialState;
        default:
            return state;
    }
};
